import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
    },
    main: {
        display: 'grid',
        width: '100%',
        flex: 1,
        minHeight: 0,
    },
    centered: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: '16px',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
    },
});
